<div class="pill" [style.background-color]="color">
  <span class="pill-content">{{ name }}</span>
</div>
